import { EventsOfTask } from 'pages/Tasks/types'
import type { ResolveActionButtonsProps } from '../../task-details-action-buttons/types'
import { getCommentButton } from '../../task-details-action-buttons/utils/get-comment-button'

export const getPendingFrontlinerOptions = (props: ResolveActionButtonsProps) => {
  const { canSendComment } = props

  return [
    ...(canSendComment
      ? [getCommentButton({ ...props, taskEvent: EventsOfTask.shareUserDataSendCommentToManager })]
      : []),
  ]
}
